var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBackground = function SvgBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 361 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M359.5 1.5v441H1.5V28.644L30.099 1.5H359.5Z",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
};

export { SvgBackground as ReactComponent };
export default __webpack_public_path__ + "271675e551f80b5f135f08a39276883a.svg";